import { SIDE_NAV_LIGHT, NAV_TYPE_SIDE, DIR_LTR } from 'constants/ThemeConstant';
import { env } from './EnvironmentConfig'


export const APP_NAME = "Smartworks";
export const API_BASE_URL = env.API_ENDPOINT_URL;
export const PORTAL_URL = env.PORTAL_ENDPOINT_URL;
export const JIRA_URL = env.JIRA_ENDPOINT_URL;
export const APP_VERSION = env.APP_VERSION;
export const APP_PREFIX_PATH = "/app";
export const AUTH_PREFIX_PATH = "/auth";
export const PUBLIC_PREFIX_PATH = "/public";

export const THEME_CONFIG = {
  navCollapsed: false,
  sideNavTheme: SIDE_NAV_LIGHT,
  locale: "en",
  navType: NAV_TYPE_SIDE,
  topNavColor: "#3e82f7",
  headerNavColor: "",
  mobileNav: false,
  currentTheme: "light",
  direction: DIR_LTR,
};
